import { render, staticRenderFns } from "./pageFrame.vue?vue&type=template&id=285c9bdc&"
import script from "./pageFrame.vue?vue&type=script&lang=ts&"
export * from "./pageFrame.vue?vue&type=script&lang=ts&"
import style0 from "./pageFrame.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports